import { createFileRoute } from "@tanstack/react-router"
import { ChangeProjectReview } from "@/features/change-projects/components/ChangeProjectReview"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/review")({
  component: ReviewStep,
})

function ReviewStep() {
  const { changeProjectId } = Route.useParams()
  return <ChangeProjectReview changeProjectId={changeProjectId} />
}
